import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import { Box, Button, IconButton, List, ListItem, ListItemButton, ListItemText, Menu, MenuItem, Typography, useTheme } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useDispatch, useSelector } from 'react-redux';
import { LoadingButton } from '@mui/lab';
import SearchFiles from '../../../../components/SearchFiles';
import { clearRegulatoryFile, getRegulatoryFile, setRegulatoryFile } from '../../../../redux/regulatoryFileSlice';
import ConfirmDialogReuse from '../../ReuseComponents/ConfirmDialogReuse';
import { setRegulatoryFileAction } from '../../../../redux/regulatoryFileActionSlice';
import CustomizedSnackbar from '../../../../components/CustomizedSnackbar';
import { setSnackbarMessage } from '../../../../redux/snackbarMessageSlice';
import { getHasDiagramChange } from '../../../../redux/hasDiagramChangeSlice';
import { setHasFileChange } from '../../../../redux/hasFileChangeSlice';
import CircleIcon from '@mui/icons-material/Circle';
import { CustomTooltip } from '../../../../components/TooltipCustomStyle';
import TooltipStatusTitle from '../../../../components/TooltipStatusTitle';
import ErrorIcon from '@mui/icons-material/Error';
import checkUpdateSubjectSchema from '../../../../utils/checkUpdateSubjectSchema';
import { getDrgValidation } from '../../../../redux/drgValidationSlice';
import { setClickNextFile } from '../../../../redux/clickNextFileSlice';
import { v4 as uuidv4 } from 'uuid';
import { getProfile } from '../../../../redux/iaamSlice';

function RegulatoryFiles(props) {

    const { nodes, edges, statusUpdate, setStatusUpdate, setOpenCreate, setOpenEdit } = props;

    const theme = useTheme();

    const overflowingListFile = React.createRef();
    const [overflowActive, setOverflowActive] = useState(false);
    const dispatch = useDispatch();
    const [regulatoryFiles, setRegulatoryFiles] = useState([]);
    const [filteredItems, setFilteredItems] = useState([]);
    const [selectedItem, setSelectedItem] = useState(null);
    const regulatoryFile = useSelector(getRegulatoryFile);
    const [isLoading, setIsLoading] = useState(false);
    const [project, setProject] = useState();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [openDelete, setOpenDelete] = useState(false);
    const [fileData, setFileData] = useState();
    const [loading, setLoading] = useState(false);
    const hasDiagramChange = useSelector(getHasDiagramChange);
    const drgValidation = useSelector(getDrgValidation);
    const profile = useSelector(getProfile);

    useEffect(() => {
        const project = JSON.parse(localStorage.getItem('project'));
        if (project) {
            setProject(project);
        }
    }, []);

    const handleSearch = (term) => {
        const filtered = regulatoryFiles.filter(item =>
            item.regulatory_diagram_name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredItems(filtered);
    };

    const getSelectRegulatoryFile = async (regulatory_diagram_id) => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatory/${regulatory_diagram_id}`);
            if (response.ok) {
                const result = await response.json();
                dispatch(setRegulatoryFile(result));
                return result;
            } else {
                throw new Error(`Error: ${response.status}`);
            }
        } catch (error) {
            dispatch(setSnackbarMessage({
                open: true,
                message: 'Error occurred while fetching DRG.',
                status: 'error',
            }));
            return undefined;
        };
    };

    const onClickRegulatoryFile = async (item) => {
        dispatch(setClickNextFile(item.regulatory_diagram_id));
        if (selectedItem === null) {
            const regulatory_file = await getSelectRegulatoryFile(item.regulatory_diagram_id);
            localStorage.setItem('regulatory-file', JSON.stringify(regulatory_file));
            setSelectedItem(item.regulatory_diagram_id);
        } else if (selectedItem !== item.regulatory_diagram_id) {
            // ตรวจสอบว่า diagram changed หรือไม่
            if (hasDiagramChange) {
                dispatch(setHasFileChange(true));
            } else {
                const regulatory_file = await getSelectRegulatoryFile(item.regulatory_diagram_id);
                localStorage.setItem('regulatory-file', JSON.stringify(regulatory_file));
                setSelectedItem(item.regulatory_diagram_id);
            }
        }
    };

    const getListRegulatorys = async () => {

        if (isLoading) return; // ป้องกันการเรียกซ้ำถ้ากำลังโหลดอยู่

        setIsLoading(true);
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatories/${project?.project_id}`);

            if (!response.ok) {
                throw new Error(`Error: ${response.status}`);
            }

            const result = await response.json();

            const isSubjectSchema = await checkUpdateSubjectSchema(dispatch);

            if (!isSubjectSchema) {
                const updateValidation = result.map(drg => {
                    const existingError = drg?.validation?.find(v => v.code === 'SUBJECT_SCHEMA_FETCH_FAILED');
                    if (existingError) {
                        return drg; // ถ้ามี error อยู่แล้ว ไม่ต้องเพิ่มซ้ำ
                    }
                    return {
                        ...drg,
                        validation: [...(drg?.validation || []), {
                            code: 'SUBJECT_SCHEMA_FETCH_FAILED',
                            summary: 'Subject schema fetch failed. Please try again.',
                            detail: []
                        }]
                    }
                });
                setRegulatoryFiles(updateValidation);
            }
            setRegulatoryFiles(result);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false); // ปิด Loading เสมอไม่ว่าจะสำเร็จหรือไม่
        }
    };

    const handleClick = (event, item) => {
        setAnchorEl(event.currentTarget);
        setFileData(item);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const onClickEdit = async () => {
        let regulatory_file = undefined;
        const response = await fetch(`${process.env.REACT_APP_API_URL}/regulatory-diagram/get-regulatory/${fileData.regulatory_diagram_id}`);
        if (response.ok) {
            const result = await response.json();
            regulatory_file = result
            dispatch(setRegulatoryFile(result));
            localStorage.setItem('regulatory-file', JSON.stringify(result));

        } else {
            console.error(response.status);
            regulatory_file = undefined;
        }
        let file_updated = regulatory_file;

        if (file_updated) {
            if (selectedItem && (selectedItem === fileData.regulatory_diagram_id)) {
                file_updated = {
                    ...file_updated,
                    diagram: {
                        nodes: nodes,
                        edges: edges
                    }
                };
            }
            handleClose();
            dispatch(setRegulatoryFileAction(file_updated));
            setOpenEdit(true);
        }
    };

    const onClickDelete = () => {
        handleClose();
        setOpenDelete(true);
    };

    const onDeleteClose = () => {
        handleClose();
        setOpenDelete(false);
    };

    const onClickClone = () => {
        handleClose();
        handleCloneRegulatoryFile();
    };

    const handleDelete = async () => {
        setLoading(true);
        // const selected_id = [fileData?.regulatory_diagram_id.toString()];
        const drg_id = fileData?.regulatory_diagram_id.toString();
        const project_id = project?.project_id;
        // console.log("drg_id", drg_id);
        // console.log("project_id", project_id);

        const requestOptions = {
            method: "DELETE"
        };

        // const response = await fetch(process.env.REACT_APP_API_URL + '/regulatory-diagram/delete-regulatories', requestOptions);
        const response = await fetch(process.env.REACT_APP_API_VALIDATION_URL + `/verify/delete-regulatory?drg_id=${drg_id}&project_id=${project_id}`, requestOptions);
        if (response.status === 200) {
            const result = await response.json();
            if (result?.status) {
                setLoading(false);
                onDeleteClose();
                dispatch(setSnackbarMessage({
                    open: true,
                    message: result?.message || "DRG cannot be deleted. It is used in policies.",
                    status: 'error',

                }));
            } else {
                if (fileData?.regulatory_diagram_id === regulatoryFile?.regulatory_diagram_id) {
                    dispatch(clearRegulatoryFile());
                    localStorage.removeItem('regulatory-file');
                    setSelectedItem(null);
                }
                setStatusUpdate(true);
                setLoading(false);
                onDeleteClose();
                dispatch(setSnackbarMessage({
                    open: true,
                    message: "DRG deleted successfully.",
                    status: 'success',

                }));
            }
        } else {
            console.error(response.status);
            setLoading(false);
            dispatch(setSnackbarMessage({
                open: true,
                message: `Error status: ${response.status}`,
                status: 'error',

            }));
        }
    };

    const createCloneName = (originalName) => {
        let counter = 1;
        let newName = `${originalName}-copy${counter}`;

        while (regulatoryFiles.some(drg => drg.regulatory_diagram_name === newName)) {
            counter++;
            newName = `${originalName}-copy${counter}`;
        }

        return newName;
    };

    const handleCloneRegulatoryFile = async () => {
        try {
            const id = uuidv4();
            const requestOptions = {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...fileData,
                    regulatory_diagram_id: id,
                    regulatory_diagram_name: createCloneName(fileData.regulatory_diagram_name),
                    updater_id: profile.inum,
                    updater: profile.displayName,
                    created_at: Date.now(),
                    updater_at: Date.now(),
                })
            };
            const response = await fetch(process.env.REACT_APP_API_URL + '/regulatory-diagram/add-regulatory/' + project.project_id, requestOptions);
            if (response.ok) {
                setStatusUpdate(true);
                const regulatory_file = await getSelectRegulatoryFile(id);
                localStorage.setItem('regulatory-file', JSON.stringify(regulatory_file));
                setSelectedItem(id);
            } else {
                throw response;
            }
        } catch (error) {
            dispatch(setSnackbarMessage({
                open: true,
                message: 'Error occurred while cloning DRG.',
                status: 'error',
            }));
        };
    };

    useEffect(() => {
        if (!project?.project_id) return;

        const isFirstLoad = regulatoryFiles.length === 0;

        if (statusUpdate || isFirstLoad) {
            getListRegulatorys();

            if (statusUpdate) {
                setStatusUpdate(false);
            }
        }

    }, [project?.project_id, statusUpdate])

    useEffect(() => {
        if (regulatoryFiles.length > 0) {
            setFilteredItems(prevFilteredItems => {
                const newItems = regulatoryFiles.map(newFile => {
                    if (drgValidation && newFile.regulatory_diagram_id === drgValidation.regulatory_diagram_id && drgValidation.validation) {
                        return {
                            ...newFile,
                            validation: drgValidation.validation
                        };
                    }
                    const oldFile = prevFilteredItems.find(p => p.regulatory_diagram_id === newFile.regulatory_diagram_id);
                    if (oldFile && oldFile.validation) {
                        return {
                            ...newFile,
                            validation: oldFile.validation
                        };
                    }
                    return newFile;
                });
                return newItems;
            });
        } else {
            setFilteredItems([]);
        }
    }, [regulatoryFiles, drgValidation])

    useEffect(() => {
        if (regulatoryFile) {
            setSelectedItem(regulatoryFile.regulatory_diagram_id);
        }
    }, [regulatoryFile?.regulatory_diagram_id])

    useLayoutEffect(() => {
        const { current } = overflowingListFile;
        const trigger = () => {
            const hasOverflow = current.scrollHeight > current.clientHeight;
            setOverflowActive(hasOverflow);
        };

        if (current) {
            if ('ResizeObserver' in window) {
                new ResizeObserver(trigger).observe(current);
            }

            trigger();
        }

    }, [overflowingListFile]);

    useEffect(() => {
        if (drgValidation?.validation) {
            setFilteredItems(prevFilteredItems => {
                if (prevFilteredItems.length === 0) {
                    return prevFilteredItems;
                }
                return prevFilteredItems.map(file => {
                    if (file.regulatory_diagram_id === drgValidation.regulatory_diagram_id) {
                        return {
                            ...file,
                            validation: drgValidation.validation
                        }
                    }
                    return file;
                })
            });
        }
    }, [drgValidation?.validation, drgValidation?.regulatory_diagram_id])

    return (
        <div className='h-full'>
            <SearchFiles onSearch={handleSearch} onAddClick={setOpenCreate} isOverflow={overflowActive} isLoading={isLoading} />
            <List ref={overflowingListFile} className='h-[calc(100%-106px)]' sx={{ padding: 0, overflowY: "auto" }} >
                {filteredItems.map((item) => {
                    const filterSummary = item?.validation?.map(v => v.summary);
                    return (
                        <ListItem
                            key={item.regulatory_diagram_id}
                            disablePadding
                            className='border-b hover:bg-slate-50 cursor-pointer'
                            sx={selectedItem === item.regulatory_diagram_id ?
                                { backgroundColor: 'rgba(25,118,210,0.1)' } : undefined
                            }
                            secondaryAction={
                                <IconButton
                                    edge="end"
                                    aria-label="more"
                                    sx={{ width: '24px', height: '24px', right: 3 }}
                                    id="basic-button"
                                    aria-controls={open ? 'menu-action' : undefined}
                                    aria-haspopup="true"
                                    aria-expanded={open ? 'true' : undefined}
                                    onClick={(e) => handleClick(e, item)}
                                >
                                    <MoreVertIcon fontSize="small" className='text-gray-400' />
                                </IconButton>
                            }
                        >
                            <ListItemButton
                                role={undefined}
                                onClick={() => onClickRegulatoryFile(item)}
                                dense
                            >
                                {(item?.validation && item?.validation.length > 0) &&
                                    <CustomTooltip title={<TooltipStatusTitle headerTitle="Error" listDetails={filterSummary} />} arrow placement="top" tooltipcolorstyle={theme.palette.error.main}>
                                        <ErrorIcon sx={{
                                            color: theme.palette.error.main,
                                            fontSize: 14,

                                        }} />
                                    </CustomTooltip>
                                }
                                <ListItemText
                                    className='text-gray-500 py-1'
                                    primary={item.regulatory_diagram_name}
                                    primaryTypographyProps={{
                                        fontSize: 14,
                                        paddingLeft: '10px',
                                        color: selectedItem === item.regulatory_diagram_id ? '#1976d2' : undefined,
                                        fontWeight: (selectedItem === item.regulatory_diagram_id) ? 'bold' : undefined
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    )
                })}
            </List>
            <Menu
                id="menu-action"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                <MenuItem onClick={onClickEdit}>Edit</MenuItem>
                <MenuItem onClick={onClickClone}>Clone</MenuItem>
                <MenuItem onClick={onClickDelete}>Delete</MenuItem>
            </Menu>
            <ConfirmDialogReuse
                open={openDelete}
                maxWidth={"sm"}
                content={
                    <div>
                        <Typography variant="subtitle1">Are you sure you want to delete regulatory file "{fileData?.regulatory_diagram_name}" ?</Typography>
                    </div>
                }
                actions={
                    <div className='grid grid-cols-2 gap-2'>
                        <LoadingButton
                            variant="contained"
                            loading={loading}
                            onClick={() => handleDelete()}
                        >
                            Confirm
                        </LoadingButton>
                        <Button
                            variant="outlined"
                            onClick={() => onDeleteClose()}
                        >
                            Cancel
                        </Button>
                    </div>
                }
            />
            {/* <CustomizedSnackbar
                open={openResponse}
                setOpen={setOpenResponse}
                message={responseMessage}
                status={responseStatus}
            /> */}
            <CustomizedSnackbar />
        </div>
    )
}

export default RegulatoryFiles